import React from 'react';
import style from './index.module.css';
import Avatar from '@mui/material/Avatar';
import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';

const ClientCard = (props) => {
	const theme = useTheme();
	const isDark = theme.palette.mode === 'dark';

	return (
		<motion.div 
			whileHover={{ y: -10, scale: 1.05 }}
			className={style.card}
			style={{
				backgroundColor: isDark ? 'rgba(255, 255, 255, 0.05)' : theme.palette.background.paper,
				color: theme.palette.text.primary,
				boxShadow: isDark ? '0 10px 30px rgba(0,0,0,0.4)' : '0 10px 30px rgba(0,0,0,0.05)',
				border: `1px solid ${isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)'}`,
			}}
		>
			<div className={style.cardBody}>
				<div className={style.iconStyle}>
					<Avatar sx={{ 
						bgcolor: theme.palette.primary.main,
						width: 56,
						height: 56,
						fontSize: '1.5rem',
						fontWeight: 700
					}}>
						{props.name.charAt(0)}
					</Avatar>
				</div>
				<p className={style.cardHeadingText}>{props.name}</p>
				{props.sign && (
					<p className={style.cardSignText} style={{ color: theme.palette.primary.main }}>
						{props.sign}
					</p>
				)}
				<p className={style.cardContentText} style={{ color: theme.palette.text.secondary }}>
					{props.from}
				</p>
			</div>
		</motion.div>
	);
};

export default ClientCard;
